/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customFieldWithValueDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	value: z.string(),
})

export type CustomFieldWithValueDataSchema = z.infer<typeof customFieldWithValueDataSchema>
